import { LoaderFunctionArgs, redirect } from "react-router";

export default async function proposalsLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/proposals/active");
  return routeParams;
}
